import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-split-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/split"
    infiniteScroll={true}
    message_if_none = 'No split jobs yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-split-jobs'));
}
